import { useState } from "react";
import { Accordion, Icon } from "semantic-ui-react";
import { ICalculation } from "../../models/calculation";

const capitalize = (s: string) => {
    return s.charAt(0).toUpperCase() + s.slice(1);
};

interface IProps {
    //npShifts: INPShift[];
    calculation: ICalculation;
}

export const NPShiftsDisplay = ({ calculation }: IProps) => {
    const [activeHour, setActiveHour] = useState(-1);
    const npShifts = calculation.npShifts;
    npShifts.forEach(npShift => {
        Object.entries(npShift.values).forEach(x => {
            if (x[1].value === 0) delete npShift.values[x[0]];
        });
    });

    const handleAccordionClick = (index: number) => {
        activeHour === index ? setActiveHour(-1) : setActiveHour(index);
    };

    return (
        <Accordion id="accordion-NPShiftsDisplay" className="np-shifts-accordion">
            {npShifts.map((npShift, index1) => (
                <div id={`div-NPShiftsDisplay-a-${index1}`} key={npShift.hour}>
                    <Accordion.Title
                        id={`accordion-title-a-${index1}`}
                        active={activeHour === npShift.hour}
                        index={0}
                        onClick={() => handleAccordionClick(npShift.hour)}
                    >
                        <Icon id={`icon-NPShiftsDisplay-a-title-a-${index1}`} name="dropdown" />
                        {//npShift.hour.toString().padStart(2, "0") + ":30"
                            calculation.activeTimestamps?.find((element) => element.key === npShift.hour)?.text
                        }
                    </Accordion.Title>
                    <Accordion.Content id={`accordion-content-NPShiftsDisplay-a-${index1}`} active={activeHour === npShift.hour}>
                        {Object.entries(npShift.values).map((elem, index2) => (
                            <p id={`p-NPShiftsDisplay-a-${index1}-${index2}`} key={elem[0]}>
                                <label id={`label-NPShiftsDisplay-a-${index1}-${index2}`}>{elem[0].toUpperCase()}:&nbsp;</label>
                                {Object.entries(elem[1]).map((np, index3) => (
                                    <div id={`div-np-shift-element-a-${index1}-${index2}-${index3}`} key={np[0]} className="np-shift-element">
                                        <p id={`p-NPShiftsDisplay-a-${index1}-${index2}-${index3}`}>
                                            <label id={`label-NPShiftsDisplay-a-${index1}-${index2}-${index3}`} >
                                                {capitalize(np[0])}
                                                :&nbsp;
                                            </label>
                                            {np[1]}
                                        </p>
                                    </div>
                                ))}
                            </p>
                        ))}
                    </Accordion.Content>
                </div>
            ))}
        </Accordion>
    );
};
